// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_iw-0";
export var fileCarousel = "_iw-2";
export var removeFileButton = "_iw-1";